import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { MainMenu } from '../main-menu';
import styles from '../../styles/styles.css';

import { DropDown as Component } from './drop-down';
import type { IDeps, TDropDown } from './models';

export const DropDown = createWidget<IDeps, TDropDown>({
    MainMenu,
    styles,
})(Component);
